export const APP_LOCALES = ["es", "en"];
export const DEFAULT_APP_LOCALE = "es";
export function resolveAppLocale(value) {
    return String(value || "")
        .trim()
        .toLowerCase()
        .startsWith("en")
        ? "en"
        : DEFAULT_APP_LOCALE;
}
export function resolveInitialAppLocale(input) {
    if (input.stored)
        return resolveAppLocale(input.stored);
    if (input.browser)
        return resolveAppLocale(input.browser);
    return DEFAULT_APP_LOCALE;
}
